import { Icon, ICONS_ENUM } from '@sanlam-glacier/app-common/components';
import styles from './stage-status.module.scss';
import clsx from 'clsx';
import { Stage } from 'modules/case-tracking/types/case-tracking.enums';

type StageStatusProps = {
  stage: number;
  stageDescription: string;
  isCancelled: boolean;
  isTablet?: boolean;
  isProgressVersion?: boolean;
};

const totalStages = 4;

export const StageStatus = ({
  stage,
  stageDescription,
  isCancelled,
  isTablet,
  isProgressVersion
}: StageStatusProps) => {
  const renderStageCircles = () => {
    const elements = [];

    for (let i = 1; i <= totalStages; i++) {
      const isComplete = i < stage || stageDescription === Stage.Stage4;
      const isActive = i === stage;

      let circle;

      if (isCancelled && isActive) {
        circle = (
          <Icon
            icon={ICONS_ENUM.ALERT_ERROR_OUTLINE}
            className={clsx(styles.stageCircle, styles.stageCircleCancelled)}
          />
        );
      } else if (isComplete) {
        circle = (
          <Icon
            icon={ICONS_ENUM.NAVIGATION_CHECK}
            className={clsx(styles.stageCircle, styles.stageCircleComplete)}
          />
        );
      } else if (isActive) {
        circle = <p className={clsx(styles.stageCircle, styles.stageCircleActive)}>{i}</p>;
      } else {
        circle = <span className={clsx(styles.stageCircle, styles.stageCircleTodo)}>{i}</span>;
      }

      elements.push(
        <div
          className={clsx(styles.stageItem, isProgressVersion && styles.stageItemAnimated)}
          key={i}
          style={isProgressVersion ? { animationDelay: `${(i - 1) * 0.2}s` } : undefined}
        >
          {circle}
          {i < totalStages && (
            <div
              className={clsx(
                styles.stageConnector,
                i < stage && styles.stageConnectorComplete,
                i === stage && !isCancelled && styles.stageConnectorActive,
                i > stage && !isCancelled && styles.stageConnectorUpcoming,
                isTablet && styles.stageMobileConnector,
                isProgressVersion && styles.stageConnectorAnimated
              )}
              style={isProgressVersion ? { animationDelay: `${(i - 1) * 0.2 + 0.3}s` } : undefined}
            />
          )}
        </div>
      );
    }

    return elements;
  };

  return (
    <div className={clsx(styles.stageStatus, isProgressVersion ? styles.stageStatusProgress : '')}>
      <div className={styles.stageStatusRow}>{renderStageCircles()}</div>
      <p>{isProgressVersion}</p>
      {!isTablet && !isProgressVersion && (
        <div className={styles.stageStatusLabel}>{stageDescription}</div>
      )}
    </div>
  );
};
